import { getPostFeedMetadataPage } from '@wix/ambassador-blog-frontend-adapter-public-v2-post-feed-page/http';
import type { GetPostFeedMetadataPageResponse } from '@wix/ambassador-blog-frontend-adapter-public-v2-post-feed-page/types';
import { createAction } from '@wix/communities-blog-client-common';
import type { CommonThunkAction } from '@app/types/common-thunk-action.type';

export const fetchPostListMetadataRequest = createAction('postListMetadata/FETCH_REQUEST');
export const fetchPostListMetadataSuccess = createAction(
  'postListMetadata/FETCH_SUCCESS',
  (payload: GetPostFeedMetadataPageResponse) => payload,
);
export const setPostListMetadataParams = createAction('postListMetadata/SET_PARAMS');
export const fetchPostListMetadataFailure = createAction('postListMetadata/FETCH_FAILURE');

export const fetchPostListMetadata =
  (): CommonThunkAction<unknown> =>
  async (dispatch, getState, { httpClient, errorHandler }) => {
    dispatch(fetchPostListMetadataRequest());

    const { withErrorHandler, getResolvedError } = errorHandler;
    const params = getState().listMetadataParams;

    try {
      const result = await withErrorHandler(
        () => httpClient.request(getPostFeedMetadataPage(params!)),
        {
          errorCodesMap: { applicationError: { PERMISSION_DENIED: false, UNAUTHENTICATED: false } },
        },
      );

      dispatch(fetchPostListMetadataSuccess(result.data));
    } catch (error) {
      getResolvedError(error);
      dispatch(fetchPostListMetadataFailure(error));
    }
  };
